// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_home__1tl71","info":"Home_info__2ISgW"};